import {Global, http, Method} from './api-util';

export async function imJoinGroup({imGroupId, imUserId}) {
    return http({
        method: Method.PUT,
        url: Global.BASE_URL + '/api/im-group/join',
        data: {
            imGroupId,
            imUserId
        }
    }).then(res=>res.data)
}

export async function imQuitGroup({imGroupId, imUserId}) {
    return http({
        method: Method.PUT,
        url: Global.BASE_URL + '/api/im-group/quit',
        data: {
            imGroupId,
            imUserId
        }
    }).then(res=>res.data)
}

export async function imGroupInfo({id}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + `/api/im-group/${id}`
    }).then(res=>res.data)
}

export async function imUserList({groupId}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + '/api/im-user',
        params: {
            groupId
        }
    }).then(res=>res.data)
}

export async function imUserInfo({imUserId}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + `/api/im-user/${imUserId}`
    }).then(res=>res.data)
}

export async function addImUser() {
    return http({
        method: Method.POST,
        url: Global.BASE_URL + '/api/im-user',
        data: {}
    }).then(res=>res.data)
}

export async function modifyImUser({imUserId, userId, nickname, avatar, gender}) {
    return http({
        method: Method.PUT,
        url: Global.BASE_URL + `/api/im-user/${imUserId}`,
        data: {
            userId,
            nickname,
            avatar,
            gender
        }
    }).then(res=>res.data)
}

export const imSocket = ({imUserId}) => {
    return `${Global.BASE_SOCKET}/api/socket/im/${imUserId}`
}

/*
export async function imUserSign({userId}) {
    return http({
        method: Method.GET,
        url: Global.BASE_URL + `/api/im/user-sign`,
        params: {
            userId
        }
    }).then(res => res.data)
}

export async function imDeleteAccount({userId}) {
    return http({
        method: Method.DELETE,
        url: Global.BASE_URL + `/api/im/account/${userId}`
    })
}*/
